import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Select } from 'src/domains/players/webview/components/form/select/Select';
import { RealityCheckPopupState, RealityCheckState } from './RealityCheck.state';
import { SelectWrapper } from './RealityCheck.style';
import {
    SectionWrapper,
    Description,
    HeadlineWrapper,
    HeadlineIconWrapper,
    SectionHeadline,
    InfoIconWrapper,
} from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/responsibleGambling/ResponsibleGambling.style';
import { Toggle } from 'src/components/toggle/Toggle';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

interface RealityCheckFormPropsType {
    state: RealityCheckState;
}

export const RealityCheck = observer('RealityCheck', ({ state }: RealityCheckFormPropsType) => {
    const common = useCommon();
    const appPlayersState = AppPlayersState.get(common);
    const { signupPopupState } = appPlayersState;

    const languagesState = LanguagesState.get(common);

    const [popupState] = React.useState(() => new RealityCheckPopupState(signupPopupState, languagesState));

    const placeholder = languagesState.getTranslation(
        'signup-journey.reality-check.duration.placeholder',
        'Choose a frequency'
    );

    return (
        <SectionWrapper data-test='reality-check'>
            <HeadlineWrapper>
                <HeadlineIconWrapper>
                    <SectionHeadline data-test='section-headline'>
                        <I18n
                            langKey='signup-journey.reality-check.title'
                            defaultText='Turn on reality check'
                        />
                    </SectionHeadline>
                    <InfoIconWrapper onClick={popupState.renderRealityCheckPopup} />
                </HeadlineIconWrapper>

                <Toggle
                    toggleActive={state.onSwitch}
                    isActive={state.isSwitched}
                    variant='dark'
                />
            </HeadlineWrapper>

            <Description data-test='description'>
                <I18n
                    langKey='signup-journey.reality-check.description'
                    defaultText='Set a time limit for how long you are active.'
                />
            </Description>

            {state.isSwitched ? (
                <SelectWrapper>
                    <Select
                        labelText={
                            <I18n
                                langKey='signup-journey.reality-check.duration.label'
                                defaultText='Time period'
                            />
                        }
                        placeholder={placeholder}
                        options={state.realityCheckOptions}
                        state={state.selectedDuration}
                        isDisabled={false}
                        onChange={state.onChange}
                        dataTest='sign-up-select-reality-check'
                    />
                </SelectWrapper>
            ) : null}
        </SectionWrapper>
    );
});
